export default __webpack_public_path__ + "static/media/Non_veg_dot_Icon.8eec01c1.svg";